module.exports = __webpack_public_path__ + "static/media/progarm-logo-charcoal.29a9fae3.svg";